import { Navigate } from 'react-router-dom';
import { useEmitenteAtivo } from '../context/EmitenteAtivoContext';

/**
 * Os documentos vivem dentro do cadastro da empresa, não em tela separada.
 * Essa rota `/documentos` redireciona para o painel NF-e do emitente ativo
 * (ou para a lista de empresas se nenhum estiver selecionado).
 */
export default function DocumentosRedirect() {
  const { emitenteId } = useEmitenteAtivo();
  if (emitenteId) {
    return <Navigate to={`/empresa/${emitenteId}/painel/nfe`} replace />;
  }
  return <Navigate to="/emitentes" replace />;
}
